const NavbarVariant2 = ({ theme, font, editableData = {}, renderEditable }) => {
  const getText = (key, defaultValue) => {
    const value = editableData[key];
    return typeof value === "string" ? value : value?.text || defaultValue;
  };

  return (
    <nav className="w-full py-4 px-6 flex justify-between items-center border-b border-gray-300 bg-white shadow-sm">
      <div className="flex space-x-4" style={{ fontFamily: font.mainText }}>
        <a
          href="#"
          className="px-3 py-1 rounded-full text-sm font-medium hover:bg-gray-100"
          style={{ color: theme.textColor }}
        >
          {renderEditable
            ? renderEditable("page_1", getText("page_1", "Home"))
            : getText("page_1", "Home")}
        </a>
        <a
          href="#"
          className="px-3 py-1 rounded-full text-sm font-medium hover:bg-gray-100"
          style={{ color: theme.textColor }}
        >
          {renderEditable
            ? renderEditable("page_2", getText("page_2", "About"))
            : getText("page_2", "About")}
        </a>
      </div>

      <div className="text-xl font-bold" style={{ color: theme.primaryColor }}>
        {renderEditable
          ? renderEditable("brand", getText("brand", "BrandName"))
          : getText("brand", "BrandName")}
      </div>

      <div className="flex space-x-4" style={{ fontFamily: font.mainText }}>
        <a
          href="#"
          className="px-3 py-1 rounded-full text-sm font-medium hover:bg-gray-100"
          style={{ color: theme.textColor }}
        >
          {renderEditable
            ? renderEditable("page_3", getText("page_3", "Services"))
            : getText("page_3", "Services")}
        </a>
        <a
          href="#"
          className="px-3 py-1 rounded-full text-sm font-medium hover:bg-gray-100"
          style={{ color: theme.textColor }}
        >
          {renderEditable
            ? renderEditable("page_4", getText("page_4", "Contact"))
            : getText("page_4", "Contact")}
        </a>
      </div>
    </nav>
  );
};

export default NavbarVariant2;
